import { CancelIconButton, DeleteIconButton, Grid } from "@compass/core";
import { FilePanel, InlineEditDataModel } from "components";
import { ContributorMatchFile, Permission, PermissionAction, UploadFile } from "generated/openApi";
import { useInlineEditDataModel } from "hooks";
import produce from "immer";
import "moment-timezone";
import { isAuthorized } from "services";
import { initDataModel } from "utils";

export const MatchFile = (props: {
  rootPermission: Permission;
  matchFile: ContributorMatchFile;
  setMatchFile: (matchFile: ContributorMatchFile) => void;
  cancelCreate: () => void;
}) => {
  const { removing, canCancel, canRemove, cancel, remove } = useInlineEditDataModel({
    dataModel: props.matchFile,
    setDataModel: props.setMatchFile,
    cancelCreate: props.cancelCreate,
  });

  return (
    <InlineEditDataModel
      noPadding
      overflow="auto"
      actions={
        <>
          {isAuthorized(props.rootPermission, PermissionAction.Delete) && canRemove && (
            <DeleteIconButton onClick={remove} size="small" />
          )}
          {canCancel && <CancelIconButton onClick={cancel} size="small" />}
        </>
      }
      content={
        <FilePanel
          border={false}
          fileName={props.matchFile.uploadFile.fileName}
          fileRef={props.matchFile.uploadFile.fileRef}
          fileSize={props.matchFile.uploadFile.fileSize}
          uploadingData={props.matchFile.uploadFile?.uploadingData}
          imagePreviewData={props.matchFile.uploadFile?.imagePreviewData}
          onFileChange={(fileName, fileSize, uploadingData) => {
            props.setMatchFile(
              produce(props.matchFile, (draft) => {
                draft.uploadFile = initDataModel<UploadFile>({
                  fileName: fileName,
                  fileSize: fileSize,
                  uploadingData: uploadingData,
                });
              })
            );
          }}
        />
      }
      removing={removing}
    />
  );
};
